// Boot-phase profiler: cheap performance marks so a slow first load is
// diagnosable on any device (window.__govcrmBoot in a remote inspector, or
// the console summary). Phases: moduleStart -> importsDone -> piniaReady ->
// clerkPluginInstalled -> mounted -> authLoaded -> meLoaded.
interface BootBag {
  __govcrmBoot: Record<string, number>
}

export function markBoot(phase: string) {
  const bag = (window as unknown as BootBag).__govcrmBoot
  if (bag && bag[phase] === undefined) bag[phase] = Math.round(performance.now())
}

export function reportBoot() {
  const bag = (window as unknown as BootBag).__govcrmBoot
  if (!bag) return
  const entries = Object.entries(bag).sort((a, b) => a[1] - b[1])
  const lines = entries.map(([k, v], i) => `${k}=${v}ms${i ? ` (+${v - entries[i - 1][1]})` : ''}`)
  console.info('[govcrm boot] ' + lines.join(' → '))
}
